export default [
    {
        id: 1,
        name: 'Fruit & Vegetables',
        icon: 'https://img-cdn.misfitsmarket.com/boysenberry/assortment-preview/fruits-and-vegetables.svg',
        externalSkus: [111504, 118758, 112281, 111493, 114820, 117622],
        items: [
            {
                externalSku: 111504,
                slug: 'organic-pomelo',
                name: 'Organic Pomelo',
                msrp: 4.49,
                price: 3.99,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_332_sm_2020-07-06_21-16-10.jpg',
            },
            {
                externalSku: 118758,
                slug: 'jumbo-blueberries-98-oz',
                name: 'Jumbo Blueberries, 9.8 Oz',
                msrp: 8.99,
                price: 6.99,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8505_sm_2024-01-29_16-13-20.jpg',
            },
            {
                externalSku: 112281,
                slug: 'organic-brussels-sprouts-1-lb',
                name: 'Organic Brussels Sprouts, 1 Lb',
                msrp: 4.99,
                price: 4.99,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_1209_sm_2020-11-11_09-20-34.jpg',
            },
            {
                externalSku: 111493,
                slug: 'organic-pineapple',
                name: 'Organic Pineapple',
                msrp: 5.99,
                price: 5.99,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_317_sm_2022-08-25_13-46-07.jpg',
            },
            {
                externalSku: 114820,
                slug: 'organic-mini-hass-avocados-5-6-ct',
                name: 'Organic Mini Hass Avocados, 5-6 Ct',
                msrp: 7.99,
                price: 6.49,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_4229_sm_2022-01-05_10-53-01.jpg',
            },
            {
                externalSku: 117622,
                slug: 'organic-heirloom-tomato-with-compostable-packaging-2-lbs',
                name: 'Organic Heirloom Tomato with Compostable Packaging, 2 Lbs',
                msrp: 7.99,
                price: 6.99,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_7296_sm_2023-02-14_20-35-45.jpg',
            },
        ],
    },
    {
        id: 2,
        name: 'Meat & Seafood',
        icon: 'https://img-cdn.misfitsmarket.com/boysenberry/assortment-preview/meat-and-seafood.svg',
        externalSkus: [113793, 118301, 118612, 114748, 114747, 116262],
        items: [
            {
                externalSku: 113793,
                slug: 'niman-ranch-bacon-ends-pieces-12-oz',
                name: 'Bacon Ends & Pieces, 12 Oz',
                msrp: 9.99,
                price: 5.99,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_3000_sm_2021-10-11_09-48-08.jpg',
            },
            {
                externalSku: 118301,
                slug: 'boston-sword-tuna-salmon-tails-atlantic-12-oz',
                name: 'Salmon Tails, Atlantic, 12 Oz',
                msrp: 5.99,
                price: 5.09,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8016_sm_2023-09-19_13-31-00.jpg',
            },
            {
                externalSku: 118612,
                slug: 'frontiere-natural-meats-grass-fed-ground-beef-85-lean-16-oz-1-lb',
                name: 'Grass-Fed Ground Beef, 85% Lean, 16 Oz (1 Lb)',
                msrp: 7.99,
                price: 7.99,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8357_sm_2023-12-12_20-53-38.jpg',
            },
            {
                externalSku: 114748,
                slug: 'mission-driven-meat-seafood-chicken-breast-antibiotic-free-boneless-skinless-14-oz',
                name: 'Chicken Breast, Antibiotic-Free, Boneless Skinless, 14 Oz',
                msrp: 5.99,
                price: 5.39,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_4119_sm_2022-06-07_12-10-01.jpg',
            },
            {
                externalSku: 114747,
                slug: 'frontiere-natural-meats-ground-bison-90-lean-12-oz',
                name: 'Ground Bison, 90% Lean, 12 Oz',
                msrp: 10.99,
                price: 10.99,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_4118_sm_2022-10-10_11-38-19.jpg',
            },
            {
                externalSku: 116262,
                slug: 'marys-whole-chicken-free-range-32-oz-2-lbs',
                name: 'Whole Chicken, Free-Range, 32 Oz (2 Lbs)',
                msrp: 6.99,
                price: 6.99,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_5882_sm_2022-09-20_18-08-28.jpg',
            },
        ],
    },
    {
        id: 3,
        name: 'Dairy & Deli',
        icon: 'https://img-cdn.misfitsmarket.com/boysenberry/assortment-preview/dairy-and-deli.svg',
        externalSkus: [117083, 118368, 114538, 117310, 114267, 116736],
        items: [
            {
                externalSku: 117083,
                slug: 'vital-farms-pasture-raised-small-eggs-1-dz',
                name: 'Pasture-Raised Small Eggs, 1 Dz',
                msrp: 5.49,
                price: 4.59,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6732_sm_2023-09-20_12-08-24.jpg',
            },
            {
                externalSku: 118368,
                slug: 'little-sesame-hummus-caramelized-onion-8-oz',
                name: 'Hummus, Caramelized Onion, 8 Oz',
                msrp: 4.99,
                price: 4.69,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8089_sm_2023-10-23_17-24-44.jpg',
            },
            {
                externalSku: 114538,
                slug: 'true-story-kurobuta-prosciutto-3-oz',
                name: 'Kurobuta Prosciutto, 3 Oz',
                msrp: 7.99,
                price: 7.99,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_3861_sm_2022-02-08_17-27-06.jpg',
            },
            {
                externalSku: 117310,
                slug: 'neutral-carbon-neutral-organic-whole-milk-64-fl-oz',
                name: 'Carbon Neutral Organic Whole Milk, 64 Fl Oz',
                msrp: 5.99,
                price: 5.39,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6959_sm_2023-11-10_16-23-02.jpg',
            },
            {
                externalSku: 114267,
                slug: 'organic-valley-organic-finely-shredded-three-cheese-mexican-blend-6-oz',
                name: 'Organic Finely Shredded Three Cheese Mexican Blend, 6 Oz',
                msrp: 6.49,
                price: 6.49,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_3566_sm_2024-01-12_12-17-15.jpg',
            },
            {
                externalSku: 116736,
                slug: 'imperfect-foods-grass-fed-whole-milk-greek-yogurt-16-oz',
                name: 'Grass-Fed Whole Milk Greek Yogurt, 16 Oz',
                msrp: 3.89,
                price: 2.99,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6382_sm_2023-09-20_21-03-47.jpg',
            },
        ],
    },
    {
        id: 4,
        name: 'Bakery & Pantry',
        icon: 'https://img-cdn.misfitsmarket.com/boysenberry/assortment-preview/bakery-and-pantry.svg',
        externalSkus: [118562, 116124, 115559, 116815, 115915, 117445],
        items: [
            {
                externalSku: 118562,
                slug: 'bagelista-new-york-bagel-take-bake-plain-16-oz',
                name: 'New York Bagel, Take & Bake, Plain, 16 Oz',
                msrp: 4.99,
                price: 4.99,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8306_sm_2023-11-27_21-26-46.jpg',
            },
            {
                externalSku: 116124,
                slug: 'odds-ends-organic-creamy-peanut-butter-salted-16-oz-1-lb',
                name: 'Organic Creamy Peanut Butter, Salted, 16 Oz (1 Lb)',
                msrp: 6.99,
                price: 4.99,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_5710_sm_2022-11-15_12-46-17.jpg',
            },
            {
                externalSku: 115559,
                slug: 'nature-nates-organic-raw-and-unfiltered-honey-16-oz-1-lb',
                name: 'Organic Raw and Unfiltered Honey, 16 Oz (1 Lb)',
                msrp: 9.99,
                price: 9.89,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_5103_sm_2022-05-10_21-39-57.jpg',
            },
            {
                externalSku: 116815,
                slug: 'cento-black-beans-155-oz',
                name: 'Black Beans, 15.5 Oz',
                msrp: 1.99,
                price: 1.69,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6461_sm_2023-09-19_19-27-15.jpg',
            },
            {
                externalSku: 115915,
                slug: 'barbaras-peanut-butter-puffins-11-oz',
                name: 'Peanut Butter Puffins, 11 Oz',
                msrp: 4.99,
                price: 4.99,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_5489_sm_2023-09-21_12-31-47.jpg',
            },
            {
                externalSku: 117445,
                slug: 'odds-ends-us-grown-broken-white-jasmine-rice-32-oz',
                name: 'U.S. Grown Broken White Jasmine Rice, 32 Oz',
                msrp: 7.99,
                price: 5.99,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_7103_sm_2024-02-05_10-03-40.jpg',
            },
        ],
    },
    {
        id: 5,
        name: 'Snacks & Beverages',
        icon: 'https://img-cdn.misfitsmarket.com/boysenberry/assortment-preview/snacks-and-beverages.svg',
        externalSkus: [118339, 113208, 112674, 117976, 116665, 118157],
        items: [
            {
                externalSku: 118339,
                slug: 'liquid-death-sparkling-mountain-water-100-naturally-flavored-mango-chainsaw-16-fl-oz',
                name: 'Sparkling Mountain Water, 100% Naturally Flavored, Mango Chainsaw, 16 Fl Oz',
                msrp: 1.99,
                price: 1.29,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8057_sm_2023-10-10_11-41-24.jpg',
            },
            {
                externalSku: 113208,
                slug: 'lesserevil-organic-popcorn-himalayan-pink-salt-5-oz',
                name: 'Organic Popcorn, Himalayan Pink Salt, 5 Oz',
                msrp: 3.99,
                price: 3.69,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_2340_sm_2021-06-08_10-55-42.jpg',
            },
            {
                externalSku: 112674,
                slug: 'uglies-kettle-chips-original-sea-salt-6-oz',
                name: 'Kettle Chips, Original Sea Salt, 6 Oz',
                msrp: 3.99,
                price: 3.99,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_1602_sm_2024-02-02_10-28-06.jpg',
            },
            {
                externalSku: 117976,
                slug: 'pipcorn-upcycled-cinnamon-twists-45-oz',
                name: 'Upcycled Cinnamon Twists, 4.5 Oz',
                msrp: 4.49,
                price: 4.09,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_7656_sm_2023-09-20_15-57-34.jpeg',
            },
            {
                externalSku: 116665,
                slug: 'imperfect-foods-cold-pressed-orange-juice-32-fl-oz-1-qt',
                name: 'Cold Pressed Orange Juice, 32 Fl Oz (1 Qt)',
                msrp: 7.99,
                price: 5.29,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6311_sm_2022-12-23_11-02-29.jpg',
            },
            {
                externalSku: 118157,
                slug: 'olipop-sparkling-tonic-root-beer-12-fl-oz-4-ct',
                name: 'Sparkling Tonic, Root Beer, 12 Fl Oz (4 Ct)',
                msrp: 9.99,
                price: 9.99,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_7859_sm_2023-09-21_17-23-44.jpg',
            },
        ],
    },
    {
        id: 6,
        name: 'Plant-Based',
        icon: 'https://img-cdn.misfitsmarket.com/boysenberry/assortment-preview/plant-based.svg',
        externalSkus: [115095, 115495, 118557, 116762, 118549, 116754],
        items: [
            {
                externalSku: 115095,
                slug: 'hodo-organic-tofu-extra-firm-10-oz',
                name: 'Organic Tofu, Extra Firm, 10 Oz',
                msrp: 4.49,
                price: 4.09,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_4551_sm_2022-03-22_21-03-29.jpg',
            },
            {
                externalSku: 115495,
                slug: 'minor-figures-organic-oat-milk-32-fl-oz-1-qt',
                name: 'Organic Oat Milk, 32 Fl Oz (1 Qt)',
                msrp: 4.99,
                price: 4.49,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_5034_sm_2023-08-23_11-38-30.jpg',
            },
            {
                externalSku: 118557,
                slug: 'harmless-harvest-organic-coconut-yogurt-plain-unsweetened-24-oz',
                name: 'Organic Coconut Yogurt, Plain Unsweetened, 24 Oz',
                msrp: 7.99,
                price: 6.79,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8301_sm_2023-11-17_19-54-31.jpg',
            },
            {
                externalSku: 116762,
                slug: 'just-egg-plant-based-folded-egg-8-oz',
                name: 'Plant-Based Folded Egg, 8 Oz',
                msrp: 5.99,
                price: 5.99,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6408_sm_2022-12-23_15-18-21.jpg',
            },
            {
                externalSku: 118549,
                slug: 'mush-overnight-oats-peanut-butter-5-oz',
                name: 'Overnight Oats, Peanut Butter, 5 Oz',
                msrp: 2.49,
                price: 2.49,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_8293_sm_2023-11-13_12-05-24.jpg',
            },
            {
                externalSku: 116754,
                slug: 'miyokos-creamery-organic-hint-of-sea-salt-cultured-vegan-butter-8-oz',
                name: 'Organic Hint of Sea Salt Cultured Vegan Butter, 8 Oz',
                msrp: 5.99,
                price: 5.99,
                portion: 1,
                photoMed: 'https://img-cdn.misfitsmarket.com/item_images/item_info_6400_sm_2023-09-20_13-06-35.jpg',
            },
        ],
    },
];
